import TSService from './service-connector';



let service = new TSService({url: process.env.REACT_APP_WS_ADDRESS});
export default service;


// WEBPACK FOOTER //
// ./src/svc/index.js